export default {
    title: 'Typing Battle',
    common: {
        time: '{minutes}m {seconds}s',
        kpmUnit: '{count} KPM',
        noKill: 'No kills',
        notEnoughStar: {
            title: 'Not enough Praise Stars',
            message: 'You need 1 Praise Star to start the Typing Battle.',
            confirm: 'OK',
        },
    },
    index: {
        back: 'Back',
        classroomTitle: '{school} Grade {grade} Class {class_name}',
        header: {
            name: 'Name',
            phase: 'Phase',
            accuracy: 'Acc.',
            time: 'Time',
            kpm: 'KPM',
            date: 'Date',
        },
        meMark: 'Me',
        recentRecord: 'Recent',
        myRanking: 'My Ranking',
        empty: 'No records yet.',
        startRaid: 'Start Raid',
        startFailed: 'Could not start the raid.',
    },
    inplay: {
        phase: 'Phase {phase}',
        exit: 'Exit',
        combo: 'Combo',
        transition: {
            phase: 'Phase',
            completed: 'cleared!',
            awakening: 'Phase {phase} boss awakening...',
            loading: 'Loading...',
            skip: 'Skip',
        },
        nextLabel: 'Next: {next}',
        inputLabel: 'Submit',
        leaveModal: {
            title: 'Leave now?',
            message: 'If you leave now, the Typing Battle will end with your current record.<br />Are you sure?',
            no: 'No',
            yes: 'Yes',
        },
        contentError: {
            title: 'Could not load content',
            message: 'Please try again in a moment.',
            confirm: 'OK',
        },
    },
    result: {
        gameOver: 'Game Over',
        bestRecord: 'New personal best! Head back to the lobby to check the ranking.',
        reachedPhase: 'Reached Phase',
        defeatedBoss: 'Bosses Defeated',
        defeatedUnit: '',
        lastBoss: 'Last Boss',
        targetKpmTooltip: 'Grade {grade} target KPM: {targetKpm}',
        ranking: 'Back to Lobby',
        retry: 'Start Again',
        registered: {
            title: 'Added to your class ranking!',
            message: 'Higher phase ranks first; ties are broken by accuracy and KPM.',
        },
        stats: {
            maxCombo: 'Max Combo',
            accuracy: 'Accuracy',
            typo: 'Typos',
            time: 'Time',
            kpm: 'KPM',
            comboUnit: '{count} combo',
            accuracyUnit: '{count}%',
            typoUnit: '{count}',
            kpmUnit: '{count} KPM',
        },
    },
};
